/**
 * DraftIndicator — Small badge showing unsaved changes exist.
 */

interface DraftIndicatorProps {
  isDirty: boolean
}

export function DraftIndicator({ isDirty }: DraftIndicatorProps) {
  if (!isDirty) return null
  return (
    <span className="ml-2 rounded-md bg-amber-100 px-1.5 py-0.5 text-[10px] font-medium text-amber-700">
      Draft
    </span>
  )
}
